import React from "react";
import {
    Card,
    CardContent,
} from "@mui/material";
import "../css/components.css";
import { ReactComponent as NotAllowed } from "../img/icons/accesinterdit.svg";
export const ErrorBoundaryMessage = (props) => {
    return (
        <Card style={{ marginTop: "50px" }}>
            <CardContent className="notAllowed">
                <NotAllowed width="50%" height="150px" fill="#D0D7E4" />

                <div className="Errormessage" >
                    Quelque chose s'est mal passé
                </div>

            </CardContent>
        </Card>
    );
};